import styled from 'styled-components';

export const EnhancedNotificationWrapper = styled.div`
  width: 400px;
  max-height: 500px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  // padding: 12px 0;
  margin-bottom: 20px;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1999;
`;

export const CollapsedNotificationWrapper = styled(EnhancedNotificationWrapper)`
  width: 400;
`;

export const HeaderControls = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px 0px;
  border-bottom: 1px solid #E5E7EB;
  background: #fff;
  gap:10px;
`;

export const HeaderLeft = styled.div`
  flex: 1;
  padding-bottom: 8px;
  min-width: 0;
`;

export const CollapsedHeaderLeft = styled(HeaderLeft)`
  padding-bottom: 0;
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TabContainer = styled.div`
  display: flex;
  flex: 1;
  border-bottom: 1px solid #E5E7EB;
 // background: #F9FAFB;
`;

export const Tab = styled.button`
  //flex: 1;
  padding: 12px 16px;
  background: ${props => props.active ? '#fff' : '#fff'};
  border: none;
  border-bottom: 2px solid ${props => props.active ? '#0C53BB' : 'transparent'};
  color: ${props => props.active ? '#0C53BB' : '#6B7280'};
  font-weight: ${props => props.active ? '600' : '500'};
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    background: ${props => props.active ? '#fff' : '#F3F4F6'};
  }
`;

export const ContentArea = styled.div`
  padding: 16px;
  overflow-y: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FileItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #E9ECF1;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const FileIcon = styled.div`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.failed ? "#F6DBDB":"#F3F4F6"} ;
  border-radius: 6px;
  color: #6B7280 ;
`;

export const FileInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const FileName = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const FileSize = styled.div`
  font-size: 12px;
  color: #6B7280;
  margin-bottom: 8px;
`;

// Which client/matter a file was uploaded for. Stamped when the upload
// starts, so it stays right after the user has moved to another page.
export const ClientLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #0C53BB;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 4px;
  background: #E5E7EB;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 4px;
`;

export const ProgressFill = styled.div`
  height: 100%;
  background: #0C53BB;
  width: ${props => props.progress}%;
  transition: width 0.3s ease;
`;

export const ProgressText = styled.div`
  font-size: 12px;
  color: #6B7280;
  text-align: right;
`;

export const SuccessIcon = styled.div`
  width: 20px;
  height: 20px;
  background: #10B981;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
`;

export const ErrorIcon = styled.div`
  width: 20px;
  height: 20px;
  background: #EF4444;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  color: #6B7280;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: #F3F4F6;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  color: #6B7280;
  font-size: 14px;
  padding: 32px 16px;
`;

export const BottomStatus = styled.div`
  padding: 12px 16px;
  border-top: 1px solid #E5E7EB;
  //background: #F9FAFB;
`;

export const StatusRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const SuccessStatusIcon = styled.div`
  width: 16px;
  height: 16px;
  background: #10B981;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
`;

export const ErrorStatusIcon = styled.div`
  width: 16px;
  height: 16px;
  background: #EF4444;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
`;

export const StatusText = styled.span`
  font-size: 12px;
  color: #48566B;
  
  font-weight: 500;
  span {
  color:${props => props.success ? '#16B361' :  '#EF4444'};
  }
`;

export const CollapsedStatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const CollapsedHeaderControls = styled(HeaderControls)`
  padding: 12px 16px;
  border-bottom: none;
  min-height: 44px;
  box-sizing: border-box;
`;

export const CollapsedHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const CollapsibleIcon = styled.div`
  cursor: pointer;
  color: #6B7280;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    color: #374151;
  }
`;

export const CloseIcon = styled.div`
  cursor: pointer;
  color: #6B7280;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    color: #374151;
  }
`;

export const ErrorMessage = styled.div`
  color: #EF4444;
  font-size: 12px;
  margin-top: 4px;
`;

export const RetryButton = styled.button`
  flex-shrink: 0;
  align-self: center;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #fff;
  border: 1px solid #0C53BB;
  cursor: pointer;
  padding: 4px 10px;
  border-radius: 4px;
  color: #0C53BB;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;

  &:hover {
    background: #EFF4FC;
  }

  &:disabled {
    color: #9CA3AF;
    border-color: #D1D5DB;
    cursor: not-allowed;
    background: #fff;
  }
`;

export const RetryAllRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  border-bottom: 1px solid #E5E7EB;
  background: #F9FAFB;
`;

export const RetryAllHint = styled.span`
  font-size: 12px;
  color: #4B5563;
`;

// "These files were cut off by a reload — pick them again to finish."
export const ResumeBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 12px;
  border-bottom: 1px solid #F3D9A4;
  background: #FFF8E6;
`;

export const ResumeHeadline = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #7A4B00;
`;

export const ResumeText = styled.div`
  font-size: 12px;
  color: #4B5563;
  line-height: 1.4;
`;

export const ResumeButtons = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const FailedStatus = styled.span`
  font-size: 12px;
  color: #C24140;
`;

export const RenameRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
`;

export const RenameInput = styled.input`
  flex: 1;
  min-width: 0;
  font-size: 12px;
  padding: 4px 6px;
  border: 1px solid #D1D5DB;
  border-radius: 4px;
  color: #111827;

  &:focus {
    outline: none;
    border-color: #0C53BB;
  }
`;

export const RenameRetryButton = styled.button`
  flex-shrink: 0;
  background: #0C53BB;
  border: none;
  cursor: pointer;
  padding: 4px 10px;
  border-radius: 4px;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;

  &:hover {
    background: #0A459C;
  }

  &:disabled {
    background: #9CA3AF;
    cursor: not-allowed;
  }
`;

export const RotatedIcon = styled.div`
  transform: rotate(180deg);
`; 

export const LoadingSpinner = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  .spinner {
    width: 12px;
    height: 12px;
    border: 2px solid #E5E7EB;
    border-top: 2px solid #0C53BB;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

// One stage of the Uploads list ("Uploading from your computer",
// "Extracting", "In line", "Done").
export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 600;
  color: #48566B;
  margin-bottom: -4px;
`;

export const SectionToggle = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-size: 12px;
  font-weight: 500;
  color: #0C53BB;
  cursor: pointer;
`;

export const StatusSubText = styled.div`
  font-size: 12px;
  color: #6B7280;
  margin: -4px 0 0 24px;
`;

